import styled from "@emotion/styled";
import React from "react";

interface Props {
  variant: "incoming" | "outgoing";
  children: React.ReactNode;
}

function ChatMessageBubble(props: Props) {
  return <ChatMessageBubble.Root variant={props.variant}>{props.children}</ChatMessageBubble.Root>;
}

ChatMessageBubble.Root = styled.div<{ variant: "incoming" | "outgoing" }>`
  background-color: ${(props) => (props.variant === "incoming" ? "#E0EBFC" : "white")};
  color: #283847;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 24px;
  border-start-start-radius: ${(props) => (props.variant === "incoming" ? "2px" : "24px")};
  border-start-end-radius: ${(props) => (props.variant === "outgoing" ? "2px" : "24px")};
  margin-inline-end: ${(props) => (props.variant === "incoming" ? "40px" : "0")};
  margin-inline-start: ${(props) => (props.variant === "outgoing" ? "40px" : "0")};
  padding: 12px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  word-break: break-word;
`;

ChatMessageBubble.Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  font-size: 10px;
  color: #53606c;
  font-weight: 700;
`;

ChatMessageBubble.HeaderChild = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  margin-inline-start: auto;
`;

ChatMessageBubble.Time = styled.span`
  opacity: 0.5;
`;

export default ChatMessageBubble;
